var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c("div", { staticClass: "desc-enterprise" }, [
        _c("span", [_vm._v(_vm._s(_vm.companyName))]),
        _vm._v(" 的企业综合评级为 "),
        _c("span", [_vm._v(_vm._s(_vm.scoreTotalLevel))]),
        _vm._v(" 级，企业综合评分在 "),
        _c("span", [_vm._v(_vm._s(_vm.industryName) + "行业")]),
        _vm._v(" 中的位于 "),
        _c("span", [_vm._v("前" + _vm._s(_vm.industryRank) + "%")]),
      ]),
      _c("div", { staticClass: "fx" }, [
        _c(
          "div",
          { staticClass: "chart fx-full" },
          [
            _c("img", {
              staticClass: "chart-bg",
              attrs: {
                src: require("@/assets/panel/dash-board.png"),
                alt: "",
                srcset: "",
              },
            }),
            _c("MyEcharts", {
              ref: "myEchart",
              staticStyle: { width: "100%", height: "240px" },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "fx-full info-box pt-60" },
          [
            _c(
              "el-descriptions",
              { attrs: { column: 1 } },
              [
                _c(
                  "el-descriptions-item",
                  { attrs: { label: "综合评级", labelClassName: "label" } },
                  [
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.scoreTotalLevel) + "级"),
                    ]),
                  ]
                ),
                _c(
                  "el-descriptions-item",
                  { attrs: { label: "行业排名", labelClassName: "label" } },
                  [
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(_vm.industryName) +
                          "行业前" +
                          _vm._s(_vm.industryRank) +
                          "%"
                      ),
                    ]),
                  ]
                ),
                _c(
                  "el-descriptions-item",
                  { attrs: { label: "区域排名", labelClassName: "label" } },
                  [
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.regionName) +
                          "前" +
                          _vm._s(_vm.regionRank) +
                          "%"
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        _vm._l(_vm.scoreVO, function (item, i) {
          return _c("EnterpriseSub", { key: i, attrs: { data: item } })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }